module.exports = __webpack_public_path__ + "img/StudentsOnly_Offers.7124b290.png";